module.exports = __webpack_public_path__ + "img/part-1-title.caf8ff29.png";